import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-container__inner" }

import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  align?: "left" | "center" | "right";
}

export default /*#__PURE__*/_defineComponent({
  __name: 'button-container',
  props: {
    modifires: { type: [String, Array, Boolean] },
    align: {}
  },
  setup(__props: any) {

const props = __props;


const componentClass = () =>
  mapModifires(
    "button-container",
    mergeModifires(props.modifires, props.align && `align-${props.align}`)
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})